import { slugify } from "../../utils/slugify.js";
import type { Locale } from "../Locale.js";
import type { Product } from "../Product.js";

export function getProductPath(locale: Locale, { name }: Pick<Product, "name">): string {
	return slugify(name[locale]);
}
